import type {z} from "zod/v4-mini"
import type {GraphNodeDefinition} from "#graph/nodes/graph/types"
import type {ParameterValue} from "#graph/nodes/graph/helpers"

export type StructParameters<StructType extends {[key in Key]: unknown}, Key extends string = string> = {
    struct: {[Field in Key]: ParameterValue<StructType[Field]>}
}

export const structDefinition = <StructType extends {[key in Key]: unknown}, Key extends string = string>(
    nodeClass: string,
    validation: {
        parameters: z.ZodMiniType<{struct: {[Field in Key]: ParameterValue<StructType[Field]>}}, {struct: {[Field in Key]: ParameterValue<StructType[Field]>}}>
        returns: z.ZodMiniType<StructType>
    },
) =>
    ({
        nodeClass,
        validation,
    }) satisfies GraphNodeDefinition<StructType, StructParameters<StructType, Key>>
